import { themeVariables } from '@noths/polaris-design-system-abstract-theme';
import { css } from 'styled-components';

export const reviewsLink = css`
  display: inline-flex;
  align-items: center;
  text-decoration: none;
  color: inherit;
  font-size: var(${themeVariables.typography.body.sizes.sm.fontSize});

  small {
    font-size: var(${themeVariables.typography.body.sizes.sm.fontSize});
  }
`;
